import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Npm extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M7.385,16.846h3.077V15.308h3.076V9.154H7.385Zm3.077-6.154H12v3.077H10.462Zm4.307-1.538v6.154h3.077V10.692h1.539v4.616h1.538V10.692h1.539v4.616H24V9.154ZM0,15.308H3.077V10.692H4.615v4.616H6.154V9.154H0Z" />
      </svg>
    );
  }
}

export default Npm;
